import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Form, Input, Button, Typography } from "antd";
import { Link } from "react-router-dom";

import { forgetpassword, resetpassword } from "../../services/apicall.tsx";
import { Statescontex } from "../../context/index.js";
import { colors } from "../../devdata/constants/themes";
import expandedLogo from "../../devdata/icons/marketpulse.svg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
const { Text } = Typography;

function ForgotPasswordPage() {
  const [searchParams] = useSearchParams();
  const [isTokenPresent, setIsTokenPresent] = useState(false);
  const [token, settoken] = useState("");
  const [form] = Form.useForm();
  const { setErrorshow, setErrorMessage } = Statescontex();
  const [loading, setLoading] = useState(false);
  const [isKeyboardActive, setIsKeyboardActive] = useState(false);
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  useEffect(() => {
    const token = searchParams.get("token");
    settoken(token);
    setIsTokenPresent(!!token);
  }, [searchParams]);
  useEffect(() => {
    const handleKeyboardDidShow = () => {
      setIsKeyboardActive(true);
    };

    const handleKeyboardDidHide = () => {
      setIsKeyboardActive(false);
    };

    // For mobile web, we'll use focus/blur events on inputs as a proxy for keyboard visibility
    const inputElements = document.querySelectorAll("input");

    inputElements.forEach((input) => {
      input.addEventListener("focus", handleKeyboardDidShow);
      input.addEventListener("blur", handleKeyboardDidHide);
    });

    return () => {
      inputElements.forEach((input) => {
        input.removeEventListener("focus", handleKeyboardDidShow);
        input.removeEventListener("blur", handleKeyboardDidHide);
      });
    };
  }, []);
  const handleSubmit = (values) => {
    if (isTokenPresent) {
      const { password, confPassword } = values;

      // Validate password strength:
      const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      if (!passwordRegex.test(password)) {
        setErrorMessage("h_Password does not meet requirements");
        setErrorshow(true);
        console.log("Password does not meet requirements");
        return;
      }

      // Validate password confirmation:
      if (confPassword !== password) {
        setErrorshow(true);
        setErrorMessage("h_Passwords do not match");
        console.log("Passwords do not match");
        return;
      }
      console.log("Password reset request sent", { password });
      resetpassword(
        token,
        password,
        confPassword,
        setLoading,
        setErrorMessage,
        setErrorshow
      );
    } else {
      const { username } = values;

      forgetpassword(username, setLoading, setErrorMessage, setErrorshow);
      console.log("API request sent for email:", username);
      setErrorMessage("l_Reset link sent to your email if the email exists.");
      setErrorshow(true);
    }
  };

  return (
    <div className="flex h-screen sm:h-auto flex-col sm:flex-row">
      {/* Full height screen on desktop, auto on mobile, flex direction changes on small screens */}
      <div className="sm:w-1/2 relative h-1/2 sm:h-screen bg-gradient-to-br from-[#005C32] to-[#11CD77] hidden sm:block">
        <img
          alt="bars"
          src={require("../../devdata/assets/bars.png")}
          className="h-full"
        />

        {/* Green left/top section, hidden on mobile, visible on larger screens */}
      </div>
      <div className="sm:w-1/2 min-h-screen bg-darkMode-background flex flex-col justify-center items-center p-6 sm:p-8">
        {/* Dark right/bottom section, min-h-screen for mobile, padding adjusted */}
        {!isKeyboardActive && (
          <div className="absolute top-8">
            <Link to={"/"}>
              <img src={expandedLogo} alt="Logo" className="w-64" />
            </Link>
          </div>
        )}
        <div className="w-full sm:max-w-md flex flex-col justify-center items-center">
          {/* Container for form and headings, max width on small screens and up */}
          <h2 className="text-2xl sm:text-3xl font-semibold mb-2 text-darkMode-text text-center">
            {/* Adjusted heading text size for small screens */}
            {isTokenPresent
              ? "Set New Password for Log in"
              : "Enter Email to recieve reset link"}
          </h2>
          <div className="text-darkMode-text w-full sm:w-2/3">
            {/* White form container, full width on small screens, 2/3 on larger */}
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
              {!isTokenPresent && (
                <Form.Item
                  label={
                    <label style={{ color: colors.darkMode.text }}>Email</label>
                  }
                  name="username"
                  rules={[
                    {
                      // required: true,
                      message: "Please enter your email.",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter your email"
                    style={{
                      borderRadius: "0.5rem",
                      padding: "0.75rem",
                      color: "black",
                    }} // Input style
                    className="!bg-white !border-gray-300 focus:!ring-darkMode-greenDarker focus:ring-2 focus:!shadow-none"
                  />
                </Form.Item>
              )}

              {isTokenPresent && (
                <>
                  <Form.Item
                    label={
                      <label style={{ color: colors.darkMode.text }}>
                        Password
                      </label>
                    }
                    name="password"
                    rules={[
                      {
                        // required: true,
                        message: "Please enter a new password.",
                      },
                      {
                        validator: (_, value) => {
                          if (!value || passwordRegex.test(value)) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            "Password must be at least 8 characters and include uppercase, lowercase, number, and special character."
                          );
                        },
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder="Enter your new password"
                      style={{
                        borderRadius: "0.5rem",
                        padding: "0.75rem",
                        color: "black",
                      }} // Input style
                      className="!bg-white !border-gray-300 focus:!ring-darkMode-greenDarker focus:ring-2 focus:!shadow-none"
                      iconRender={visible => (
                        visible ? <FontAwesomeIcon icon={faEyeSlash} style={{ width: 20, height: 20 }} color="black" /> : <FontAwesomeIcon icon={faEye} style={{ width: 20, height: 20 }} color="black" />
                      )}
                    />

                  </Form.Item>
                  <Form.Item
                    label={
                      <label style={{ color: colors.darkMode.text }}>
                        Confirm Password
                      </label>
                    }
                    name="confPassword"
                    rules={[
                      {
                        // required: true,
                        message: "Please confirm your new password.",
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder="Confirm your new password"
                      style={{
                        borderRadius: "0.5rem",
                        padding: "0.75rem",
                        color: "black",
                      }} // Input style
                      iconRender={visible => (
                        visible ? <FontAwesomeIcon icon={faEyeSlash} style={{ width: 20, height: 20 }} color="black" /> : <FontAwesomeIcon icon={faEye} style={{ width: 20, height: 20 }} color="black" />
                      )}
                      className="!bg-white !border-gray-300 focus:!ring-darkMode-greenDarker focus:ring-2 focus:!shadow-none"
                    />
                  </Form.Item>
                </>
              )}

              <Form.Item>
                <button
                  type="primary"
                  htmlType="submit"
                  className="w-full rounded-xl py-2 sm:py-3" // Rounded button, padding adjusted for small screens
                  style={{
                    backgroundColor: colors.darkMode.green,
                  }}
                >
                  <span className="text-darkMode-layer3 text-base sm:text-xl font-semibold">
                    {/* Adjusted button text size for small screens */}
                    {isTokenPresent ? "Reset Password" : "Send Reset Link"}
                  </span>
                </button>
              </Form.Item>
            </Form>
          </div>
          <div className="text-center mt-3">
            <Text className="text-darkMode-text text-xl">
              Already have an account?{" "}
              <Link to="/login" className="">
                <span className="text-darkMode-green text-xl underline">
                  Log In
                </span>
              </Link>
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
